import { render, staticRenderFns } from "./PageCalculadoraItpCat.vue?vue&type=template&id=5f7ecd8e&scoped=true&"
import script from "./PageCalculadoraItpCat.vue?vue&type=script&lang=js&"
export * from "./PageCalculadoraItpCat.vue?vue&type=script&lang=js&"
import style0 from "./PageCalculadoraItpCat.vue?vue&type=style&index=0&id=5f7ecd8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ecd8e",
  null
  
)

export default component.exports